import { Resources } from 'constants/resources';

import * as React from 'react';

import { useGoBack } from 'hooks/useGoBack';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { DeleteDialog, DeleteDialogProps } from 'shared/mui/Dialogs';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { truncateString } from 'utils/truncateString';

export const CommissionsDeleteDialog: React.FC<Omit<DeleteDialogProps, 'details' | 'title'>> = (
  props,
) => {
  const translate = useTypedTranslate();
  const { goBack } = useGoBack();
  const notify = useNotify();

  const commissionName = props.record?.name || '';

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: [Resources.Commissions] });
    goBack();

    notify(translate('app.commissions.deleted', { name: commissionName }), {
      type: 'success',
    });
  };

  return (
    <DeleteDialog
      {...props}
      details={
        <>
          Комиссия <TypographyBold fontSize={16} text={truncateString(commissionName, 50)} /> будет
          удалена без возможности восстановления.
        </>
      }
      onSuccess={onSuccess}
      title="Удаление комиссии"
    />
  );
};
